import script from "./Star.vue?vue&type=script&setup=true&lang=js"
export * from "./Star.vue?vue&type=script&setup=true&lang=js"

import "./Star.vue?vue&type=style&index=0&id=2a57b64a&lang=scss"

const __exports__ = script;

export default __exports__